import { render, staticRenderFns } from "./StudentsWithLdhdOrAdd.vue?vue&type=template&id=7b1b37a0&scoped=true&"
import script from "./StudentsWithLdhdOrAdd.vue?vue&type=script&lang=js&"
export * from "./StudentsWithLdhdOrAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1b37a0",
  null
  
)

export default component.exports